<template>
  <div></div>
</template>

<script>
  export default {
    name: "base",
    data() {
      return {
        timeOutList : [],
        intervalList : [],
      }
    },
    methods: {
      setTimeOut(fun,delay) {
        let handler = setTimeout(fun,delay);
        this.timeOutList.push(handler);
      },
      setInterval(fun,delay) {
        let handler = setInterval(fun,delay);
        this.intervalList.push(handler);
      }
    },
    destroyed() {
      for(let i = 0 ; i < this.timeOutList.length; i++){
        clearTimeout(this.timeOutList[i]);
      }
      this.timeOutList = [];

      for(let i = 0 ; i < this.intervalList.length; i++){
        clearInterval(this.intervalList[i]);
      }
      this.intervalList = [];
    }
  }
</script>

<style scoped>

</style>
